var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderRightNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_10684",
    "data-name": "Group 10684",
    transform: "translate(-980 -6561.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ATLAS_Building",
    "data-name": "ATLAS Building",
    transform: "translate(980 6561.406)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 47,
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 46.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33025",
    "data-name": "Path 33025",
    d: "M4746.192,2065.414l20.154,17.428-20.154,17.427",
    transform: "translate(-3728.636 4525.401)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderRightNav);
export default __webpack_public_path__ + "static/media/slider-right-nav.effaee4cdeff87d43f424d840cc8b672.svg";
export { ForwardRef as ReactComponent };